// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QR Code Modal Styles */
.qr-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.qr-modal {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.qr-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.qr-modal-header h3 {
  margin: 0;
  color: #075E54;
  font-size: 20px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: #f5f5f5;
}

.qr-modal-content {
  padding: 24px;
}

.device-info {
  text-align: center;
  margin-bottom: 24px;
}

.device-info h4 {
  margin: 0 0 4px 0;
  color: #075E54;
  font-size: 18px;
}

.device-info p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.qr-loading {
  text-align: center;
  padding: 40px 20px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #25D366;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.qr-loading p {
  color: #666;
  margin: 0;
}

.qr-error {
  text-align: center;
  padding: 40px 20px;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.qr-error p {
  color: #dc3545;
  margin: 0 0 16px 0;
  font-size: 14px;
}

.retry-btn {
  background: #25D366;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.qr-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.qr-code {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.qr-code img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.qr-instructions {
  background: #e8f5e8;
  padding: 16px;
  border-radius: 8px;
  border-left: 4px solid #25D366;
}

.qr-instructions h4 {
  margin: 0 0 12px 0;
  color: #075E54;
  font-size: 16px;
}

.qr-instructions ol {
  margin: 0;
  padding-left: 20px;
  color: #555;
}

.qr-instructions li {
  margin-bottom: 4px;
  font-size: 14px;
}

.status-message {
  text-align: center;
  margin: 16px 0;
  padding: 12px;
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
  color: #155724;
}

.status-message p {
  margin: 0;
  font-size: 14px;
}

.qr-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.refresh-btn {
  background: #25D366;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  flex: 1 1;
}

.refresh-btn:hover {
  background: #1da851;
}

.cancel-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  flex: 1 1;
}

.cancel-btn:hover {
  background: #545b62;
}

/* Responsive Design */
@media (max-width: 640px) {
  .qr-modal {
    margin: 10px;
    max-width: none;
  }
  
  .qr-modal-content {
    padding: 16px;
  }
  
  .qr-container {
    gap: 16px;
  }
  
  .qr-actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/QRCodeModal.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* QR Code Modal Styles */\n.qr-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.qr-modal {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.qr-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.qr-modal-header h3 {\n  margin: 0;\n  color: #075E54;\n  font-size: 20px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-btn:hover {\n  background: #f5f5f5;\n}\n\n.qr-modal-content {\n  padding: 24px;\n}\n\n.device-info {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.device-info h4 {\n  margin: 0 0 4px 0;\n  color: #075E54;\n  font-size: 18px;\n}\n\n.device-info p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.qr-loading {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #25D366;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.qr-loading p {\n  color: #666;\n  margin: 0;\n}\n\n.qr-error {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.error-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.qr-error p {\n  color: #dc3545;\n  margin: 0 0 16px 0;\n  font-size: 14px;\n}\n\n.retry-btn {\n  background: #25D366;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.qr-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.qr-code {\n  text-align: center;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.qr-code img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.qr-instructions {\n  background: #e8f5e8;\n  padding: 16px;\n  border-radius: 8px;\n  border-left: 4px solid #25D366;\n}\n\n.qr-instructions h4 {\n  margin: 0 0 12px 0;\n  color: #075E54;\n  font-size: 16px;\n}\n\n.qr-instructions ol {\n  margin: 0;\n  padding-left: 20px;\n  color: #555;\n}\n\n.qr-instructions li {\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n\n.status-message {\n  text-align: center;\n  margin: 16px 0;\n  padding: 12px;\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  border-radius: 6px;\n  color: #155724;\n}\n\n.status-message p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.qr-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.refresh-btn {\n  background: #25D366;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  flex: 1;\n}\n\n.refresh-btn:hover {\n  background: #1da851;\n}\n\n.cancel-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  flex: 1;\n}\n\n.cancel-btn:hover {\n  background: #545b62;\n}\n\n/* Responsive Design */\n@media (max-width: 640px) {\n  .qr-modal {\n    margin: 10px;\n    max-width: none;\n  }\n  \n  .qr-modal-content {\n    padding: 16px;\n  }\n  \n  .qr-container {\n    gap: 16px;\n  }\n  \n  .qr-actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
